import React, { Component, PropTypes } from 'react';
import cx from 'classnames'

export class LogoMark extends Component {
  static propTypes = {
    className: PropTypes.string,
    white: PropTypes.bool,
    light: PropTypes.bool,
    green: PropTypes.bool,
  }

  render() {
    if (this.props.white)
      return this.renderWhiteLogo();

    return (
      <svg
        x={0}
        y={0}
        {...this.props}
        className={cx("logo--mark", this.props.className, { 'm-light': this.props.light, 'm-green': this.props.green })}
        viewBox="0 0 512 512"
      >
        <rect
          x="145.9"
          y="219.6"
          className="logo--mark__left st2"
          width="73.2"
          height="292.9"
        />
        <polygon
          className="logo--mark__top st1"
          points="0,146.4 0,219.6 146.1,219.6 219.3,219.6 292.4,219.6 292.4,146.4 "
        />
        <rect
          x="365.6"
          y="146.4"
          className="logo--mark__top st1"
          width="146.4"
          height="73.2"
        />
        <polygon
          className="logo--mark__right st3"
          points="292.4,146.4 292.4,219.5 292.4,512.5 365.6,512.5 365.6,219.5 365.6,146.4 "
        />
        <path
          className="logo--mark__dot st0"
          d="M475.2,73.6c20.3,0,36.8-16.5,36.8-36.8S495.5,0,475.2,0s-36.8,16.5-36.8,36.8
          C438.4,57.1,454.9,73.6,475.2,73.6"
        />
      </svg>
    );
  }

  renderWhiteLogo() {
    return (
      <svg
        x={0}
        y={0}
        {...this.props}
        className={`logo--mark m-white ${this.props.className}`}
        viewBox="0 0 1000 1001"
      >
        <g>
          <polygon className="st0" points="0,286 0,429 285,429 285,1001 428,1001 428,429 428.3,429 571,429 571,1001 714,1001 714,429 1000,429 1000,286   "/>
          <path className="st0" d="M928.1,143.8c39.7,0,71.9-32.3,71.9-71.9S967.7,0,928.1,0c-39.7,0-71.9,32.3-71.9,71.9S888.4,143.8,928.1,143.8z"/>
        </g>
      </svg>

    );
  }
}
